import type { comune as it } from "../it/comune.ts";
import { formati } from "../formati.ts";

const f = formati("en");

/** Parole che tornano in più schermate. */
export const comune: typeof it = {
  "comune.salva": "Save",
  "comune.salvato": "Saved.",
  "comune.annulla": "Cancel",
  "comune.elimina": "Delete",
  "comune.chiudi": "Close",
  "comune.copia": "Copy",
  "comune.copiato": "Copied",
  "comune.mostra": "show",
  "comune.nascondi": "hide",
  "comune.lingua": "Language",
  "errori.rete": "Can't reach the Portman server. Check that it's running.",
  "errori.http": (p: { status: number }) => `The request failed (code ${p.status}).`,
  "comune.elementi": (p: { n: number }) =>
    `${f.numero(p.n)} ${f.plurale(p.n, { one: "item", other: "items" })}`,
};
